import { async } from "regenerator-runtime";
import { API_URL, API_KEY, RESULTS_PER_PAGE } from "./config";
import { AJAX } from "./helpers";

export const state = {
    recipe: {},
    search: {
        query: "",
        results: [],
        page: 1,
        resultsPerPage: RESULTS_PER_PAGE,
    },
    bookmarks: [],
};

const createRecipeObject = function (data) {
    const { recipe } = data.data;
    return {
        cookingTime: recipe.cooking_time,
        id: recipe.id,
        image: recipe.image_url,
        ingredients: recipe.ingredients,
        publisher: recipe.publisher,
        servings: recipe.servings,
        sourceUrl: recipe.source_url,
        title: recipe.title,
        //conditionaly checking for a key, if exists then assign otherwise do nothing
        ...(recipe.key && { key: recipe.key }),
    };
};
export const loadRecipe = async function (id) {
    try {
        const data = await AJAX(`${API_URL}${id}?key=${API_KEY}`);
        state.recipe = createRecipeObject(data);
        console.log(state.recipe);
        if (state.bookmarks.some((bookmark) => bookmark.id === id))
            state.recipe.bookmarked = true;
        else state.recipe.bookmarked = false;
    } catch (error) {
        console.error(`${error} 💥💥💥`);
        throw error;
    }
};

export const loadSearchResults = async function (query) {
    try {
        state.search.query = query;
        const data = await AJAX(`${API_URL}?search=${query}&key=${API_KEY}`);
        state.search.results = data.data.recipes.map((rec) => {
            return {
                id: rec.id,
                image: rec.image_url,
                publisher: rec.publisher,
                title: rec.title,
                ...(rec.key && { key: rec.key }),
            };
        });
    } catch (error) {
        console.error(`${error} 💥💥💥`);
        throw error;
    }
};

export const updateServings = function (newServings) {
    state.recipe.ingredients.forEach((ing) => {
        ///---> Formula for handling servings quantity
        // newQt = oldQt * newServings / oldServings
        // newQt = 2 * 8 / 4 =
        ing.quantity = (ing.quantity * newServings) / state.recipe.servings;
    });
    state.recipe.servings = newServings;
};

// performing Pagination
export const getSearchResultPage = function (page = state.search.page) {
    state.search.page = page;
    const start = (page - 1) * state.search.resultsPerPage; // 0, 11, 21
    const end = page * state.search.resultsPerPage;
    return state.search.results.slice(start, end);
};

const persistBookmarks = function () {
    localStorage.setItem("bookmarks", JSON.stringify(state.bookmarks));
};

export const addBookmark = function (recipe) {
    // Add to Bookmark
    state.bookmarks.push(recipe);

    // Mark current recipe as bookmarked
    if (recipe.id === state.recipe.id) state.recipe.bookmarked = true;

    persistBookmarks();
};

export const removeBookmark = function (id) {
    // Remove from Bookmarks
    const index = state.bookmarks.findIndex((el) => (el.id = id));
    console.log(index);
    state.bookmarks.splice(index, 1);
    // Mark current recipe as not  bookmarked
    if (id === state.recipe.id) state.recipe.bookmarked = false;
    persistBookmarks();
};

const init = function () {
    const storage = JSON.parse(localStorage.getItem("bookmarks"));
    if (storage) state.bookmarks = storage;
};
init();
console.log(state.bookmarks);

export const uploadRecipe = async function (newRecipe) {
    try {
        const ingredients = Object.entries(newRecipe)
            .filter(
                (entry) => entry[0].startsWith("ingredient") && entry[1] !== ""
            )
            .map((ing) => {
                const ingArr = ing[1].split(",").map(el => el.trim())
                const [quantity, unit, description] = ingArr;
                if (ingArr.length !== 3)
                    throw new Error(
                        "Wrong ingredient format! Please follow the correct format :)"
                    );

                return {
                    quantity: quantity ? +quantity : null,
                    unit,
                    description,
                };
            });
        const recipe = {
            title: newRecipe.title,
            source_url: newRecipe.sourceUrl,
            image_url: newRecipe.image,
            publisher: newRecipe.publisher,
            cooking_time: +newRecipe.cookingTime,
            servings: +newRecipe.servings,
            ingredients,
        };
        console.log(recipe);

        const data = await AJAX(`${API_URL}?key=${API_KEY}`, recipe);
        state.recipe = createRecipeObject(data);
        addBookmark(state.recipe);
    } catch (error) {
        throw error;
    }
};
